module.exports = __webpack_public_path__ + "767ab88dc42324ec81f0d02008b89d60.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2054_teaser_image.jpg
// module id = 578
// module chunks = 0